import { SkillScoreStars } from "@/components/ui/member-star-rating";
import { cn } from "@/lib/utils";

export type GameReceivedRatingData = {
  ratingsCount: number;
  averageStars: number | null;
  effectiveSkill?: number | null;
};

function formatAverageStars(value: number | null | undefined) {
  if (value == null) return "—";
  return value.toLocaleString("pt-BR", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 1,
  });
}

function formatSkillScore(score?: number | null) {
  if (score == null) return "—";
  return Number.isInteger(score) ? String(score) : score.toFixed(2).replace(".", ",");
}

type GameReceivedRatingSummaryProps = GameReceivedRatingData & {
  className?: string;
  /** Texto do rótulo superior. */
  label?: string;
};

export function GameReceivedRatingSummary({
  ratingsCount,
  averageStars,
  effectiveSkill,
  className,
  label = "Sua avaliação neste jogo",
}: GameReceivedRatingSummaryProps) {
  const starScore = effectiveSkill ?? averageStars;

  return (
    <div
      className={cn(
        "rounded-xl border border-info/20 bg-info/10 px-4 py-3 dark:border-info/30 dark:bg-info/20",
        className)}
    >
      <p className="text-xs font-semibold uppercase tracking-wide text-info dark:text-info-foreground">
        {label}
      </p>
      <div className="mt-2 flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
        <div className="min-w-0">
          {ratingsCount > 0 && averageStars != null ? (
            <p className="text-lg font-black tracking-tight text-foreground">
              Média {formatAverageStars(averageStars)}
              <span className="text-base font-bold text-info dark:text-info-foreground">
                {" "}
                / 5
              </span>
              <span className="ml-2 text-sm font-medium text-muted-foreground">
                ({ratingsCount}{" "}
                {ratingsCount === 1 ? "avaliação" : "avaliações"} neste jogo)
              </span>
            </p>
          ) : (
            <p className="text-sm text-muted-foreground">
              Você ainda não recebeu avaliações neste jogo.
            </p>
          )}
          {starScore != null && (
            <p className="mt-1 text-sm font-medium text-muted-foreground">
              Score {formatSkillScore(starScore)}
            </p>
          )}
        </div>
        {starScore != null && (
          <SkillScoreStars score={starScore} size="sm" className="sm:justify-end shrink-0" />
        )}
      </div>
    </div>
  );
}
